import { RtkqSpin, Status } from '@app/base';
import { formatters } from '@app/ui';
import { isInactivePatient, PatientLookup, useLazyGetPatientLookupsQuery } from '@app/main/api';
import { EMPTY_OPTION_SOURCE, Option, OptionSource, createEntireLoadOptionSource } from '@webinex/antik';
import { orderBy } from 'lodash';
import { useMemo } from 'react';
import { Name } from '../components';

export interface PatientLookupOption extends Option, Pick<PatientLookup, 'status' | 'address' | 'careHome'> {
  label: React.ReactNode;
  value: string;
}

export function mapPatientLookupOption(value: PatientLookup): PatientLookupOption {
  return {
    label: <Name value={value} />,
    value: value.id,
    __searchValue: formatters.name(value),
    status: value.status,
    address: value.address,
    careHome: value.careHome,
  };
}

export function usePatientOptionSource(args?: {
  statuses?: Status[];
  careHomeId?: string;
  skip?: boolean;
}): OptionSource {
  const { statuses, careHomeId, skip } = args ?? {};
  const [fetchList, { currentData }] = useLazyGetPatientLookupsQuery();

  return useMemo(() => {
    if (skip) {
      return EMPTY_OPTION_SOURCE;
    }

    return createEntireLoadOptionSource({
      fn: () =>
        fetchList({ [RtkqSpin]: false, statuses, careHomeId }, true)
          .unwrap()
          .then((values) =>
            orderBy(values, (x) => [isInactivePatient(x), formatters.name(x)]).map(mapPatientLookupOption),
          ),
      searchBy: '__searchValue',
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchList, currentData, statuses, careHomeId, skip]);
}
